export default "__VITE_ASSET__DKGqRPmZ__"